import React, { useEffect, useState } from 'react';
import {
  Box,
  Typography,
  Grid,
  Paper,
  Button,
  Divider,
  Avatar,
  RadioGroup,
  FormControlLabel,
  Radio,
  TextField,
} from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import '../../styles/Booking.scss';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import FlightTakeoffIcon from '@mui/icons-material/FlightTakeoff';
import GroupIcon from '@mui/icons-material/Group';
import ReceiptIcon from '@mui/icons-material/Receipt';
import CancelIcon from '@mui/icons-material/Cancel';
import { BOOKINGS } from '../../component/common/Routes/AppRoutes';
import PerfectScrollbar from 'react-perfect-scrollbar';
import 'react-perfect-scrollbar/dist/css/styles.css';
import { VENDOR_BOOKINGS } from '../../component/common/Routes/VendorRoutes';
import { CUSTOMER_BOOKINGS } from '../../component/common/Routes/CustomerRoutes';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchBookingRequest,
  resetBookingDetails,
  updateBookingDiscountApprovalStatusRequest,
} from '../../redux/Bookings/BookingAction';
import Loading from '../../component/ui/Loading';
import CustomButton from '../../component/ui/FormFields/Button';
import { toast, ToastContainer } from 'react-toastify';

const BookingInvoice = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { bookingId } = useParams();
  useEffect(() => {
    dispatch(fetchBookingRequest(bookingId));
    dispatch(resetBookingDetails());
  }, []);
  const user = useSelector((state) => state.auth.user);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const bookingDetails = useSelector((state) => state.booking?.booking?.data);
  console.log('bookingDetails', bookingDetails);
  const approvalMessage = useSelector(
    (state) => state.booking?.approval_message
  );
  const loadings = useSelector((state) => state.booking?.loading);
  const [initialStatus, setInitialStatus] = useState('');
  const bookingDetail = useSelector((state) => state.booking);
  const [approvalStatus, setApprovalStatus] = useState(
    bookingDetails?.approoved_status || null
  );
  const servicePrice = bookingDetails?.Order?.price;

  const adultFamilyMember = bookingDetails?.bookingFamilies?.filter((adult) => {
    return adult?.familyMember?.age >= 12;
  });

  const infantFamilyMember = bookingDetails?.bookingFamilies?.filter(
    (infant) => {
      return infant?.familyMember?.age < 2;
    }
  );
  const childFamilyMember = bookingDetails?.bookingFamilies?.filter((child) => {
    return child?.familyMember?.age >= 2 && child?.familyMember?.age < 12;
  });
  const adultDiscount = adultFamilyMember?.[0]?.familyMember?.discount || 0;
  const childDiscount = childFamilyMember?.[0]?.familyMember?.discount || 0;
  const infantDiscount = infantFamilyMember?.[0]?.familyMember?.discount || 0;
  const no_of_adult =
    adultDiscount > 0
      ? adultFamilyMember?.length -
        (adultFamilyMember?.length * adultDiscount) / 100
      : adultFamilyMember?.length;
  const no_of_child =
    childDiscount > 0
      ? childFamilyMember?.length -
        (childFamilyMember?.length * childDiscount) / 100
      : childFamilyMember?.length;
  const no_of_infant =
    infantDiscount > 0
      ? infantFamilyMember?.length -
        (infantFamilyMember?.length * infantDiscount) / 100
      : infantFamilyMember?.length;
  const no_of_service = no_of_child + no_of_infant + no_of_adult;
  useEffect(() => {
    if (approvalMessage) {
      toast.success('Complementry Status Changed', {
        position: 'top-center',
        autoClose: 3000,
        onClose: () => {
          dispatch(resetBookingDetails());
          navigate(-1);
        },
      });
    }
  }, [approvalMessage]);
  useEffect(() => {
    if (bookingDetails) {
      setApprovalStatus(bookingDetails.approove_status);
      setInitialStatus(bookingDetails.approove_status);
    }
  }, [bookingDetails]);

  const handleApprovalStatusChange = (event) => {
    setApprovalStatus(parseInt(event.target.value));
  };
  const handleApprovalStatusSubmit = async () => {
    setIsSubmitting(true);

    const payload = {
      booking_id: bookingDetails.id,
      approval_status: approvalStatus,
    };

    try {
      await dispatch(updateBookingDiscountApprovalStatusRequest(payload));
      await dispatch(fetchBookingRequest(bookingId));
    } catch (error) {
      alert('Failed to update approval status. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const service =
    bookingDetails?.service_type === 1
      ? 'Arrival'
      : bookingDetails?.service_type === 2
      ? 'Departure'
      : 'Transit';

  const loading = bookingDetail?.loading;
  if (loading) {
    return <Loading text='Loading Booking details...' />;
  }
  const adults = bookingDetails?.bookingFamilies?.filter((value, index) => {
    return value?.familyMember?.age >= 12;
  });

  const childs = bookingDetails?.bookingFamilies?.filter((value, index) => {
    return value?.familyMember?.age >= 2 && value?.familyMember?.age <= 11;
  });
  const infants = bookingDetails?.bookingFamilies?.filter((value, index) => {
    return value?.familyMember?.age < 2;
  });

  const showPendingOption = initialStatus === '2' || initialStatus === 2;

  const bookingData = [
    {
      icon: <LocationOnIcon className='location-icon' />,
      title: 'Airport Details',
      fields:
        service === 'Arrival'
          ? [
              {
                label: 'Airport',
                value: bookingDetails?.airport_name || '-',
              },
              {
                label: 'Arrival Date & Time',
                value:
                  ` ${bookingDetails?.BookingDetail?.date_of_arrival} ${bookingDetails?.BookingDetail?.time_of_arrival} ` ||
                  '-',
              },
              {
                label: 'Arrival Flight Number',
                value:
                  bookingDetails?.BookingDetail?.arrival_flight_number || '-',
              },
              {
                label: 'Arrival Airline',
                value: bookingDetails?.BookingDetail?.arrival_airlines || '-',
              },
            ]
          : service === 'Departure'
          ? [
              {
                label: 'Airport',
                value: bookingDetails?.airport_name || '-',
              },
              {
                label: 'Departure Date & Time',
                value:
                  ` ${bookingDetails?.BookingDetail?.date_of_departure} ${bookingDetails?.BookingDetail?.time_of_departure} ` ||
                  '-',
              },
              {
                label: 'Departure Flight Number',
                value:
                  bookingDetails?.BookingDetail?.departure_flight_number || '-',
              },
              {
                label: 'Departure Airline',
                value: bookingDetails?.BookingDetail?.departure_airlines || '-',
              },
            ]
          : [
              {
                label: 'Airport',
                value: bookingDetails?.airport_name || '-',
              },
              {
                label: 'Arrival Date & Time',
                value:
                  ` ${bookingDetails?.BookingDetail?.date_of_arrival} ${bookingDetails?.BookingDetail?.time_of_arrival} ` ||
                  '-',
              },
              {
                label: 'Arrival Flight Number',
                value:
                  bookingDetails?.BookingDetail?.arrival_flight_number || '-',
              },
              {
                label: 'Arrival Airline',
                value: bookingDetails?.BookingDetail?.arrival_airlines || '-',
              },
              {
                label: 'Departure Date & Time',
                value:
                  ` ${bookingDetails?.BookingDetail?.date_of_departure} ${bookingDetails?.BookingDetail?.time_of_departure} ` ||
                  '-',
              },
              {
                label: 'Departure Flight Number',
                value:
                  bookingDetails?.BookingDetail?.departure_flight_number || '-',
              },
              {
                label: 'Departure Airline',
                value: bookingDetails?.BookingDetail?.departure_airlines || '-',
              },
            ],
    },
    {
      icon: <FlightTakeoffIcon className='service-icon' />,
      title: 'Service Details',
      fields: [
        {
          label: 'Service',
          value: bookingDetails?.Service?.services || '-',
        },
        {
          label: 'Arrival/Departure',
          value: service || '-',
        },
        {
          label: 'Service Type',
          value: bookingDetails?.airport_type || '-',
        },
        {
          label: 'Number of Services',
          value: bookingDetails?.BookingDetail?.total_passengers || '-',
        },
      ],
    },
    {
      icon: <GroupIcon className='passenger-icon' />,
      title: 'Passenger Details',
      fields: [
        {
          label: 'No. of Adults',
          value: bookingDetails?.BookingDetail?.number_of_adults || '0',
        },
        {
          label: 'No. of Children',
          value: bookingDetails?.BookingDetail?.number_of_child || '0',
        },
        {
          label: 'No. of Infants',
          value: bookingDetails?.BookingDetail?.number_of_infant || '0',
        },
        {
          label: 'Total Passengers',
          value: bookingDetails?.BookingDetail?.total_passengers || '0',
        },
      ],
    },
  ];

  const currencyFormatter = new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    minimumFractionDigits: 2,
  });

  const isVendor = bookingDetails?.BookingDetail?.booked_user_type === 2;
  const orderSource = isVendor
    ? bookingDetails?.vendorBookLogs?.[0]
    : bookingDetails?.Order;
  const sgstPercentage = (
    (orderSource?.sgst / orderSource?.sub_total) * 100 || 0
  ).toFixed(0);
  const cgstPercentage = (
    (orderSource?.cgst / orderSource?.sub_total) * 100 || 0
  ).toFixed(0);
  const taxPercentage = (
    (bookingDetails?.Order?.tax / orderSource?.sub_total) * 100 || 0
  ).toFixed(0);
  const GrossAmount = parseFloat(
    bookingDetails?.BookingDetail?.total_passengers *
      bookingDetails?.Order?.price
  );
  const AdultPrice = -parseFloat(
    adultFamilyMember?.length * (adultDiscount / 100) * servicePrice
  );
  const ChildPrice = -parseFloat(
    childFamilyMember?.length * (childDiscount / 100) * servicePrice
  );
  const InfantPrice = -parseFloat(
    infantFamilyMember?.length * (infantDiscount / 100) * servicePrice
  );
  const subTotalWithoutAmount =
    GrossAmount + AdultPrice + ChildPrice + InfantPrice;
  console.log(subTotalWithoutAmount, 'subtotal');
  const orderSummary = {
    totals: [
      {
        label: 'Gross Amount',
        value: 0,
        formattedValue: currencyFormatter.format(GrossAmount || 0),
      },
      adultFamilyMember?.length > 0 && {
        label: `Adult Discount(${adultDiscount}%)`,
        value: 0,
        formattedValue: currencyFormatter.format(AdultPrice || 0),
      },
      childFamilyMember?.length > 0 && {
        label: `Child Discount(${childDiscount}%)`,
        value: 0,
        formattedValue: currencyFormatter?.format(ChildPrice || 0),
      },
      infantFamilyMember?.length > 0 && {
        label: `Infant Discount(${infantDiscount}%)`,
        value: 0,
        formattedValue: currencyFormatter.format(InfantPrice || 0),
      },
      orderSource &&
        bookingDetails?.BookingDetail?.booked_user_type === 2 && {
          label: `Vendor Commission (${orderSource?.vendor_commision_rate}%)`,
          value: orderSource?.vendor_commision || 0,
          formattedValue: currencyFormatter.format(
            -orderSource?.vendor_commision || 0
          ),
        },
      orderSource?.discount >= 0 &&
        bookingDetails?.BookingDetail?.booked_user_type === 1 && {
          label: `Booking Discount (${orderSource?.discount}%)`,
          value:
            -parseFloat(
              subTotalWithoutAmount * (orderSource?.discount / 100)
            ) || 0,
          formattedValue: currencyFormatter.format(
            -parseFloat(
              subTotalWithoutAmount * (orderSource?.discount / 100)
            ) || 0
          ),
        },
      orderSource?.sub_total >= 0 && {
        label: 'SubTotal',
        value: parseFloat(orderSource.sub_total) || 0,
        formattedValue: currencyFormatter.format(
          parseFloat(orderSource.sub_total) || 0
        ),
      },

      orderSource?.additional_payment >= 0 &&
        bookingDetails?.BookingDetail?.booked_user_type === 1 && {
          label: `Instant Booking Charge`,
          value: parseFloat(orderSource?.additional_payment) || 0,
          formattedValue: currencyFormatter.format(
            parseFloat(orderSource?.additional_payment) || 0
          ),
        },
      bookingDetails?.Order?.tax >= 0 && {
        label: `TAX (${taxPercentage}%)`,
        value: parseFloat(orderSource.tax) || 0,
        formattedValue: currencyFormatter.format(
          parseFloat(bookingDetails?.Order?.tax) || 0
        ),
      },
      orderSource?.sgst >= 0 && {
        label: `SGST (${sgstPercentage}% )`,
        value: parseFloat(orderSource.sgst) || 0,
        formattedValue: currencyFormatter.format(
          parseFloat(orderSource.sgst) || 0
        ),
      },
      orderSource?.cgst >= 0 && {
        label: `CGST (${cgstPercentage}%)`,
        value: parseFloat(orderSource.cgst) || 0,
        formattedValue: currencyFormatter.format(
          parseFloat(orderSource.cgst) || 0
        ),
      },
    ].filter(Boolean),
  };

  console.log(orderSummary);

  const totalAmount = orderSummary.totals.reduce(
    (sum, item) => sum + item.value,
    0
  );
  const formattedTotalAmount = currencyFormatter.format(totalAmount);

  const passengerInformation = {
    icon: <GroupIcon className='passenger-icon' />,
    title: 'Passengers Informations',
    fields: [
      {
        label: 'Adults',
        value: adults?.map((adult) => {
          return {
            totals: [
              {
                label: 'First Name',
                value: adult?.familyMember?.first_name || '-',
              },
              {
                label: 'Last Name',
                value: adult?.familyMember?.last_name || '-',
              },
              { label: 'Age', value: adult?.familyMember?.age || '-' },
              {
                label: 'Mobile No',
                value:
                  `+ ${adult?.familyMember?.country_code}-${adult?.familyMember?.phone}` ||
                  '-',
              },
              {
                label: 'Gender',
                value:
                  adult?.familyMember?.gender_type == 'M'
                    ? 'Male'
                    : adult?.familyMember?.gender_type == 'F'
                    ? 'Female'
                    : 'Others' || '-',
              },
              adult?.aadhar_number != ''
                ? {
                    label: 'AadharNumber',
                    value: adult?.familyMember?.aadhar_number || '-',
                  }
                : {
                    label: 'Passport Number',
                    value: adult?.familyMember?.passport_number || '-',
                  },
              { label: 'Nationality', value: adult?.familyMember?.nationality },
            ],
          };
        }),
      },
      {
        label: 'Child',
        value: childs?.map((child) => {
          return {
            totals: [
              {
                label: 'First Name',
                value: child?.familyMember?.first_name || 'Emily',
              },
              {
                label: 'Last Name',
                value: child?.familyMember?.last_name || 'Brown',
              },
              { label: 'Age', value: child?.familyMember?.age || '7' },
              {
                label: 'Mobile No',
                value:
                  `+ ${child?.familyMember?.country_code}-${child?.familyMember?.phone}` ||
                  '-',
              },
              {
                label: 'Gender',
                value:
                  child?.familyMember?.gender_type == 'M'
                    ? 'Male'
                    : child?.familyMember?.gender_type == 'F'
                    ? 'Female'
                    : 'Others' || '-',
              },
              child?.familyMember?.aadhar_number != ' '
                ? {
                    label: 'AadharNumber',
                    value: child?.familyMember?.aadhar_number || '-',
                  }
                : {
                    label: 'Passport Number',
                    value: child?.familyMember?.passport_number || '-',
                  },
              {
                label: 'Nationality',
                value: child?.familyMember?.nationality || '-',
              },
            ],
          };
        }),
      },
      {
        label: 'Infant',
        value: infants?.map((infant) => {
          return {
            totals: [
              {
                label: 'First Name',
                value: infant?.familyMember?.first_name || 'Michael',
              },
              {
                label: 'Last Name',
                value: infant?.familyMember?.last_name || 'Smith',
              },
              { label: 'Age', value: infant?.familyMember?.age || '1' },
              {
                label: 'Mobile No',
                value:
                  `+ ${infant?.familyMember?.country_code}-${infant?.familyMember?.phone}` ||
                  '-',
              },
              {
                label: 'Gender',
                value:
                  infant?.familyMember?.gender_type == 'M'
                    ? 'Male'
                    : infant?.familyMember?.gender_type == 'F'
                    ? 'Female'
                    : 'Others' || '-',
              },
              infant?.familyMember?.aadhar_number != ' '
                ? {
                    label: 'AadharNumber',
                    value: infant?.familyMember?.aadhar_number || '-',
                  }
                : {
                    label: 'Passport Number',
                    value: infant?.familyMember?.passport_number || '-',
                  },
              {
                label: 'Nationality',
                value: infant?.familyMember?.nationality || '-',
              },
            ],
          };
        }),
      },
    ],
  };
  const renderFields = (fields) =>
    fields.map((item, index) => (
      <Box key={index} className='label-value-container'>
        <Typography variant='body1' className='label-style'>
          {item.label}
        </Typography>
        <Typography variant='body1' className='value-style'>
          {item.value}
        </Typography>
      </Box>
    ));

  const hasCancellationNotes = bookingDetails?.BookingDetail?.cancel_notes;
  console.log(hasCancellationNotes);

  return (
    <>
      <ToastContainer />
      <Box className='booking-summary-body'>
        <Grid container spacing={4}>
          {bookingData.map((section, index) => (
            <Grid item xs={12} md={4} key={index}>
              <Paper elevation={4} className='booking-summary-paper'>
                <Box className='booking-summary-content-box'>
                  <Box className='booking-heading-alignment'>
                    <Avatar className='booking-summary-avatar-style'>
                      {section.icon}
                    </Avatar>
                    <Typography
                      variant='h6'
                      className='booking-summary-title-style'
                    >
                      {section.title}
                    </Typography>
                  </Box>
                  <Divider
                    sx={{
                      margin: '10px 0',
                      borderColor: '#ddd',
                      width: '100%',
                    }}
                  />
                </Box>
                <PerfectScrollbar
                  style={{
                    maxHeight: '150px',
                    overflowX: 'hidden',
                    paddingRight: '16px',
                  }}
                >
                  {renderFields(section.fields)}
                </PerfectScrollbar>
              </Paper>
            </Grid>
          ))}
          {/* Passenger Information */}
          <Grid item xs={12} md={6}>
            <Paper elevation={4} className='booking-summary-order-paper'>
              <Box className='booking-summary-order-box'>
                <Avatar className='booking-summary-order-avatar'>
                  {passengerInformation.icon}
                </Avatar>
                <Typography
                  variant='h6'
                  className='booking-summary-title-style'
                >
                  {passengerInformation.title}
                </Typography>
              </Box>
              <Divider className='booking-summary-divider' />

              {/* Passenger Categories */}
              <PerfectScrollbar
                style={{
                  maxHeight: '205px',
                  overflowX: 'hidden',
                  paddingRight: '16px',
                }}
              >
                {passengerInformation.fields?.map((category, index) => (
                  <Box key={index} mb={2}>
                    {/* Category Label */}
                    <Typography
                      variant='subtitle1'
                      align='left'
                      className='booking-passenger-info-title-style'
                    >
                      {category.label}
                    </Typography>

                    {/* Render Passenger Information */}
                    {category.value?.length > 0 ? (
                      category.value?.map((info, i) => (
                        <Box key={i} mb={1}>
                          {renderFields(info.totals)}

                          <Divider className='booking-summary-divider' />
                        </Box>
                      ))
                    ) : (
                      <Typography
                        variant='body2'
                        align='left'
                        className='booking-passenger-info-detail-style'
                      >
                        No {category.label.toLowerCase()} information available.
                      </Typography>
                    )}
                  </Box>
                ))}
              </PerfectScrollbar>
            </Paper>
          </Grid>

          {/* Order Summary */}
          <Grid item xs={12} md={6}>
            <Paper elevation={4} className='booking-summary-order-paper'>
              <Box className='booking-summary-order-box'>
                <Avatar className='booking-summary-order-avatar'>
                  <ReceiptIcon className='booking-summary-receipticon' />
                </Avatar>
                <Typography
                  variant='h6'
                  className='booking-summary-title-style'
                >
                  Order Summary
                </Typography>
              </Box>
              <Divider className='booking-summary-divider' />
              <PerfectScrollbar
                style={{
                  maxHeight: '205px',
                  overflowX: 'hidden',
                  paddingRight: '16px',
                }}
              >
                {orderSummary.totals.map((item, index) => (
                  <Box key={index} className='booking-summary-order-content'>
                    <Typography
                      variant='body1'
                      className='booking-summary-total-label'
                    >
                      {item.label}
                    </Typography>
                    <Typography
                      variant='body1'
                      className='booking-summary-total-value'
                    >
                      {item.formattedValue}
                    </Typography>
                  </Box>
                ))}
                <Divider className='booking-summary-divider' />
                <Box
                  className='booking-summary-order-content'
                  sx={{ paddingBottom: '20px' }}
                >
                  <Typography
                    variant='h6'
                    className='booking-summary-total-label'
                  >
                    Total
                  </Typography>
                  <Typography
                    variant='h6'
                    className='booking-summary-total-value'
                  >
                    {currencyFormatter.format(orderSource?.total)}
                  </Typography>
                </Box>
              </PerfectScrollbar>
            </Paper>
          </Grid>
          {bookingDetails?.BookingDetail?.vendor_gst_number && (
            <Grid item xs={12} md={6} display='flex' alignItems='center'>
              <Typography
                variant='h6'
                className='booking-summary-title-style'
                sx={{ mr: 2 }}
              >
                Vendor GST Number :
              </Typography>
              <Typography variant='body1' className='vendor-gst-text'>
                {bookingDetails.BookingDetail.vendor_gst_number}
              </Typography>
            </Grid>
          )}

          {user?.role === 'Admin' && bookingDetails?.booked_type === 2 && (
            <Grid item xs={12}>
              <Typography variant='subtitle1' gutterBottom>
                Approval Status
              </Typography>
              <Grid container spacing={2} direction='row' alignItems='center'>
                <Grid item>
                  <RadioGroup
                    value={approvalStatus}
                    onChange={handleApprovalStatusChange}
                    row
                  >
                    <FormControlLabel
                      value={1}
                      control={<Radio color='success' />}
                      label='Approved'
                    />
                    {showPendingOption && (
                      <FormControlLabel
                        value={2}
                        control={<Radio color='warning' />}
                        label='Pending'
                        disabled={isSubmitting}
                      />
                    )}
                    <FormControlLabel
                      value={3}
                      control={<Radio color='error' />}
                      label='Rejected'
                    />
                  </RadioGroup>
                </Grid>
                <Grid item>
                  <CustomButton
                    variant='contained'
                    className='success-button'
                    text='Submit Approval Status'
                    loading={loadings}
                    onClick={handleApprovalStatusSubmit}
                  />
                </Grid>
              </Grid>
            </Grid>
          )}
          {/* Cancellation Notes Box */}
          {hasCancellationNotes && (
            <Grid item xs={12}>
              <Paper elevation={2} className='booking-cancellation-paper'>
                <Box className='booking-cancellation-box'>
                  <Box className='booking-cancellation-header'>
                    <Avatar className='booking-cancellation-avatar'>
                      <CancelIcon className='cancellation-icon' />
                    </Avatar>
                    <Typography
                      variant='h6'
                      className='booking-cancellation-title'
                    >
                      Booking Cancelled
                    </Typography>
                  </Box>
                  <Divider className='booking-cancellation-divider' />
                  <Typography
                    variant='subtitle1'
                    className='booking-cancellation-subtitle'
                  >
                    Cancellation Reason:
                  </Typography>
                  <Box className='cancellation-notes-container'>
                    <Typography
                      variant='body1'
                      className='booking-cancellation-notes'
                    >
                      {bookingDetails?.BookingDetail?.cancel_notes}
                    </Typography>
                  </Box>
                </Box>
              </Paper>
            </Grid>
          )}

          {/* Next Button */}
          <Grid item xs={12} className='button-container'>
            <Button
              variant='contained'
              className='grey-button'
              onClick={() => {
                let bookingsRoute;

                if (user.role === 'Admin' || user.role === 'Staff') {
                  bookingsRoute = BOOKINGS;
                } else if (user.role === 'Vendor') {
                  bookingsRoute = VENDOR_BOOKINGS;
                } else if (user.role === 'Customer') {
                  bookingsRoute = CUSTOMER_BOOKINGS;
                }

                navigate(bookingsRoute);
              }}
            >
              Back
            </Button>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};
export default BookingInvoice;
